export var SET_CANVAS_SELECTION = 'app/logicBuilder/canvas/select';
export var SET_CANVAS_OFFSET = 'app/logicBuilder/canvas/offset';
export var SET_SELECTED_ENTITY = 'app/logicBuilder/entity/select';
export var SET_SELECTED_CUSTOM_LOGIC = 'app/logicBuilder/customLogic/select';
export var SET_OUTPUT_PARAM_SYNC = 'app/logicBuilder/output/sync';
export var RESET_SELECTED_CUSTOM_LOGIC = 'app/logicBuilder/customLogic/deselect';
export var SET_PROPERTIES_BAR_VISIBILITY = 'app/logicBuilder/propertiesBar/visibility';
export var SET_DELETE_CONFIRMATION_MODAL_VISIBILITY = 'app/logicBuilder/modal/delete';
export var SET_DUPLICATE_CONFIG_MODAL_VISIBILITY = 'app/logicBuilder/modal/duplicate_config';
export var SET_DYNAMIC_MODAL_VISIBILITY = 'app/logicBuilder/modal/dynamic';
export var SET_CHANGES_SAVING_STATE = 'app/logicBuilder/canvas/loading';
export var SET_CUSTOM_LOGIC_SUBSCRIPTION = 'app/logicBuilder/subscription';
export var CUSTOM_LOGIC_CREATE;
(function (CUSTOM_LOGIC_CREATE) {
    CUSTOM_LOGIC_CREATE["RESET"] = "app/logicBuilder/customLogic/create/reset";
    CUSTOM_LOGIC_CREATE["REQUEST"] = "app/logicBuilder/customLogic/create/request";
    CUSTOM_LOGIC_CREATE["SUCCESS"] = "app/logicBuilder/customLogic/create/success";
    CUSTOM_LOGIC_CREATE["ERROR"] = "app/logicBuilder/customLogic/create/error";
})(CUSTOM_LOGIC_CREATE || (CUSTOM_LOGIC_CREATE = {}));
export var CUSTOM_LOGIC_READ;
(function (CUSTOM_LOGIC_READ) {
    CUSTOM_LOGIC_READ["RESET"] = "app/logicBuilder/customLogic/read/reset";
    CUSTOM_LOGIC_READ["REQUEST"] = "app/logicBuilder/customLogic/read/request";
    CUSTOM_LOGIC_READ["SUCCESS"] = "app/logicBuilder/customLogic/read/success";
    CUSTOM_LOGIC_READ["ERROR"] = "app/logicBuilder/customLogic/read/error";
})(CUSTOM_LOGIC_READ || (CUSTOM_LOGIC_READ = {}));
export var CUSTOM_LOGIC_READ_ALL;
(function (CUSTOM_LOGIC_READ_ALL) {
    CUSTOM_LOGIC_READ_ALL["RESET"] = "app/logicBuilder/customLogic/readAll/reset";
    CUSTOM_LOGIC_READ_ALL["REQUEST"] = "app/logicBuilder/customLogic/readAll/request";
    CUSTOM_LOGIC_READ_ALL["SUCCESS"] = "app/logicBuilder/customLogic/readAll/success";
    CUSTOM_LOGIC_READ_ALL["ERROR"] = "app/logicBuilder/customLogic/readAll/error";
})(CUSTOM_LOGIC_READ_ALL || (CUSTOM_LOGIC_READ_ALL = {}));
export var CUSTOM_LOGIC_UPDATE;
(function (CUSTOM_LOGIC_UPDATE) {
    CUSTOM_LOGIC_UPDATE["RESET"] = "app/logicBuilder/customLogic/update/reset";
    CUSTOM_LOGIC_UPDATE["REQUEST"] = "app/logicBuilder/customLogic/update/request";
    CUSTOM_LOGIC_UPDATE["SUCCESS"] = "app/logicBuilder/customLogic/update/success";
    CUSTOM_LOGIC_UPDATE["ERROR"] = "app/logicBuilder/customLogic/update/error";
})(CUSTOM_LOGIC_UPDATE || (CUSTOM_LOGIC_UPDATE = {}));
export var CUSTOM_LOGIC_DELETE;
(function (CUSTOM_LOGIC_DELETE) {
    CUSTOM_LOGIC_DELETE["SET"] = "app/logicBuilder/customLogic/delete/set";
    CUSTOM_LOGIC_DELETE["RESET"] = "app/logicBuilder/customLogic/delete/reset";
    CUSTOM_LOGIC_DELETE["REQUEST"] = "app/logicBuilder/customLogic/delete/request";
    CUSTOM_LOGIC_DELETE["SUCCESS"] = "app/logicBuilder/customLogic/delete/success";
    CUSTOM_LOGIC_DELETE["ERROR"] = "app/logicBuilder/customLogic/delete/error";
})(CUSTOM_LOGIC_DELETE || (CUSTOM_LOGIC_DELETE = {}));
export var BLOCK_CREATE;
(function (BLOCK_CREATE) {
    BLOCK_CREATE["RESET"] = "app/logicBuilder/block/create/reset";
    BLOCK_CREATE["REQUEST"] = "app/logicBuilder/block/create/request";
    BLOCK_CREATE["SUCCESS"] = "app/logicBuilder/block/create/success";
    BLOCK_CREATE["ERROR"] = "app/logicBuilder/block/create/error";
})(BLOCK_CREATE || (BLOCK_CREATE = {}));
export var BLOCK_UPDATE;
(function (BLOCK_UPDATE) {
    BLOCK_UPDATE["RESET"] = "app/logicBuilder/block/update/reset";
    BLOCK_UPDATE["REQUEST"] = "app/logicBuilder/block/update/request";
    BLOCK_UPDATE["SUCCESS"] = "app/logicBuilder/block/update/success";
    BLOCK_UPDATE["ERROR"] = "app/logicBuilder/block/update/error";
})(BLOCK_UPDATE || (BLOCK_UPDATE = {}));
export var BLOCK_DELETE;
(function (BLOCK_DELETE) {
    BLOCK_DELETE["RESET"] = "app/logicBuilder/block/delete/reset";
    BLOCK_DELETE["REQUEST"] = "app/logicBuilder/block/delete/request";
    BLOCK_DELETE["SUCCESS"] = "app/logicBuilder/block/delete/success";
    BLOCK_DELETE["ERROR"] = "app/logicBuilder/block/delete/error";
})(BLOCK_DELETE || (BLOCK_DELETE = {}));
export var BLOCK_DUPLICATE;
(function (BLOCK_DUPLICATE) {
    BLOCK_DUPLICATE["RESET"] = "app/logicBuilder/block/duplicate/reset";
    BLOCK_DUPLICATE["REQUEST"] = "app/logicBuilder/block/duplicate/request";
    BLOCK_DUPLICATE["SUCCESS"] = "app/logicBuilder/block/duplicate/success";
    BLOCK_DUPLICATE["ERROR"] = "app/logicBuilder/block/duplicate/error";
})(BLOCK_DUPLICATE || (BLOCK_DUPLICATE = {}));
export var CONNECTOR_CREATE;
(function (CONNECTOR_CREATE) {
    CONNECTOR_CREATE["RESET"] = "app/logicBuilder/connector/create/reset";
    CONNECTOR_CREATE["REQUEST"] = "app/logicBuilder/connector/create/request";
    CONNECTOR_CREATE["SUCCESS"] = "app/logicBuilder/connector/create/success";
    CONNECTOR_CREATE["ERROR"] = "app/logicBuilder/connector/create/error";
})(CONNECTOR_CREATE || (CONNECTOR_CREATE = {}));
export var CONNECTOR_UPDATE;
(function (CONNECTOR_UPDATE) {
    CONNECTOR_UPDATE["RESET"] = "app/logicBuilder/connector/update/reset";
    CONNECTOR_UPDATE["REQUEST"] = "app/logicBuilder/connector/update/request";
    CONNECTOR_UPDATE["SUCCESS"] = "app/logicBuilder/connector/update/success";
    CONNECTOR_UPDATE["ERROR"] = "app/logicBuilder/connector/update/error";
})(CONNECTOR_UPDATE || (CONNECTOR_UPDATE = {}));
export var CONNECTOR_DELETE;
(function (CONNECTOR_DELETE) {
    CONNECTOR_DELETE["RESET"] = "app/logicBuilder/connector/delete/reset";
    CONNECTOR_DELETE["REQUEST"] = "app/logicBuilder/connector/delete/request";
    CONNECTOR_DELETE["SUCCESS"] = "app/logicBuilder/connector/delete/success";
    CONNECTOR_DELETE["ERROR"] = "app/logicBuilder/connector/delete/error";
})(CONNECTOR_DELETE || (CONNECTOR_DELETE = {}));
export var APP_OPTION_LIST;
(function (APP_OPTION_LIST) {
    APP_OPTION_LIST["RESET"] = "app/logicBuilder/app_options/reset";
    APP_OPTION_LIST["REQUEST"] = "app/logicBuilder/app_options/request";
    APP_OPTION_LIST["SUCCESS"] = "app/logicBuilder/app_options/success";
    APP_OPTION_LIST["ERROR"] = "app/logicBuilder/app_options/error";
})(APP_OPTION_LIST || (APP_OPTION_LIST = {}));
export var DUPLICATE_CUSTOM_LOGIC;
(function (DUPLICATE_CUSTOM_LOGIC) {
    DUPLICATE_CUSTOM_LOGIC["RESET"] = "app/logicBuilder/duplicate_custom_logic/reset";
    DUPLICATE_CUSTOM_LOGIC["REQUEST"] = "app/logicBuilder/duplicate_custom_logic/request";
    DUPLICATE_CUSTOM_LOGIC["SUCCESS"] = "app/logicBuilder/duplicate_custom_logic/success";
    DUPLICATE_CUSTOM_LOGIC["ERROR"] = "app/logicBuilder/duplicate_custom_logic/error";
})(DUPLICATE_CUSTOM_LOGIC || (DUPLICATE_CUSTOM_LOGIC = {}));
